import React, { useEffect, useState } from 'react';
import { Button } from '../../components/form/button';
import { useAPI } from '../../clients/quipli-service/quipli-service-client';
import { Card } from '../../components/card/card';
import { Location } from '../../clients/quipli-service/location/location';
import { TaxLocationModal } from './tax-location-modal';
import { useTaxApiV1 } from '../../clients/quipli-service/tax/tax-api-v1';
import { TaxCode } from '../../clients/quipli-service/tax/tax';

export const TaxLocationSetup = () => {
  const [setupModalOpen, setSetupModalOpen] = useState<boolean>(false);
  const { listLocations } = useAPI();
  const { searchTaxCodes, listTaxLocations } = useTaxApiV1();

  const [taxCodes, setTaxCodes] = useState<TaxCode[]>([]);

  const [taxLocations, setTaxLocations] = useState<{ taxCodeId: string; locationId: number; shippingType: string }[]>(
    [],
  );
  const [locationList, setLocationList] = useState<Location[]>([]);
  async function init() {
    const taxes = await searchTaxCodes({ pageSize: 100 });
    setTaxCodes(taxes.items);
    const taxLocationsResult = await listTaxLocations({});
    setTaxLocations(taxLocationsResult);
    const locations = await listLocations();
    setLocationList(locations);
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <div className="tax-location-setup">
      <div className={'tax-code-table py-2 pt-8 pb-8'}>
        <Card>
          <table className="w-full border-none">
            <thead>
              <tr>
                <th className={'text-left'}>
                  <span>Location Name</span>
                </th>
                <th className={'text-left'}>
                  <span>Tax Code</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {taxLocations.map((location) => {
                return (
                  <React.Fragment key={location.taxCodeId}>
                    <tr>
                      <td className={'text-left flex gap-2 items-center mt-2.5'}>
                        {locationList.find((_) => _.id == location.locationId)?.name}
                      </td>
                      <td className={'text-left'}>{taxCodes.find((_) => _.id == location.taxCodeId)?.name}</td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </Card>
      </div>
      <Button className="button-yellow" onClick={() => setSetupModalOpen(true)}>
        Create a tax location assignment
      </Button>
      <TaxLocationModal
        isOpen={setupModalOpen}
        close={() => {
          setSetupModalOpen(false);
          init();
        }}
        taxCodes={taxCodes}
      />
    </div>
  );
};
